import { Config, getCountryDomainApi, getCurrentCountry } from "@/config";
import {
    GetLocalStorageT2,
    SetLocalStorageT,
    STORE_KEY_USER_TOKEN,
} from "./storage";

// request: function() Promise
// storeKey: String
class SourceItem {
    constructor(request, storeKey) {
        this.request = request;
        this.storeKey = storeKey;
    }
}

export const TYPE_USER_TOKEN = 1;

let SourceItemList = {
    1: new SourceItem((token) => {
        const base = getCountryDomainApi(getCurrentCountry()) || Config.domainApi;
        return fetch(base + "/admin/refresh-token", {
            method: "GET",
            headers: { "Content-Type": "application/json;charset='utf-8'", jwt: token },
        }).then((res) => res.json()).then((res) => {
            return { token: res.data.token, expire: res.data.expire == undefined ? 23 * 3600 : res.data.expire };
        });
    }, STORE_KEY_USER_TOKEN),
};

export const GetToken = (type) => {
    let item  = SourceItemList[type];
    let store = GetLocalStorageT2(item.storeKey);
    if (store == null) {
        return null;
    } else {
        // token有效时长小于 30 分钟时，自动刷新token
        let nowTime = new Date().getTime();
        if (store.expire - nowTime < 3600000) {
            RefreshToken(type);
        }
        return store.data;
    }
};

export const RefreshToken = (type) => {
    let item    = SourceItemList[type];
    let store   = GetLocalStorageT2(item.storeKey);
    let promise = item.request(store && store.data ? store.data : "");
    return promise.then((data) => {
        SetLocalStorageT(item.storeKey, data.token, data.expire);
        return data.token;
    });
};
